var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboardedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#EAF4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 21.563a6.187 6.187 0 1 1 12.375 0 6.187 6.187 0 0 1-12.375 0zM33.375 24.938a5.063 5.063 0 1 1 10.125 0 5.063 5.063 0 0 1-10.125 0zM14.25 40.688C14.25 34.785 19.035 30 24.938 30c5.902 0 10.687 4.785 10.687 10.688v.003c0 .06 0 .12-.002.18a1.125 1.125 0 0 1-.544.944 19.6 19.6 0 0 1-10.142 2.81 19.6 19.6 0 0 1-10.14-2.81 1.125 1.125 0 0 1-.546-.945l-.001-.182zM37.875 40.692c0 .072 0 .145-.002.216a3.372 3.372 0 0 1-.35 1.44 15.13 15.13 0 0 0 7.591-1.516c.371-.182.613-.552.63-.964a7.313 7.313 0 0 0-10.435-6.917 12.88 12.88 0 0 1 2.566 7.736v.005z",
    fill: "#150349"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardedIcon);
export default __webpack_public_path__ + "static/media/onboarded-icon.4cb16a757f9c6fbf0f5c81adac379702.svg";
export { ForwardRef as ReactComponent };